import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MaterialModule } from '../../../../client/app/material/material.module';
import { DeviceInfoComponent } from './device-info/device-info.component';
import { ProfileComponent } from './profile/profile.component';

const routes: Routes = [{ path: '', component: ProfileComponent }];

@NgModule({
    declarations: [ProfileComponent, DeviceInfoComponent],
    imports: [CommonModule, MaterialModule, RouterModule.forChild(routes)],
    exports: [ProfileComponent]
})
export class ProfileModule {}
